module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-insert-point",
      "title": "Localizza Punto"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17ebdae4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/InsertPoint.vue
// module id = 826
// module chunks = 39